<script>
import Chart from 'chart.js';

export default {
  name: 'AnalyticsScreenResolutionsReport',
  props: {
    colors: Array,
    data: Object,
    loading: Boolean
  },
  data() {
    return {
      chart: null
    };
  },
  computed: {
    chartData() {
      if (this.data && this.data.rows) {
        const maxItems = 5;
        let rows = this.data.rows;

        // Aggregate "other" items
        if (rows.length > maxItems) {
          rows = rows.slice(0, maxItems);
        }

        const data = {
          labels: rows.map(row => row[0]),
          datasets: [
            {
              data: rows.map(row => row[1]),
              backgroundColor: this.colors,
              borderColor: 'white',
              borderWidth: 2
            }
          ]
        };

        return data;
      }
    },
    tableData() {
      const report = this.data;

      if (report) {
        const totalVisits = report.totalsForAllResults['ga:visits'];
        const tableData = report.rows.map(row => ({
          screenResolution: row[0],
          visits: parseFloat(row[1]).toLocaleString(),
          visitsPercentage: (parseFloat(totalVisits > 0 ? row[1] / totalVisits : 0) * 100).toFixed(1).toLocaleString()
        }));

        return tableData;
      } else {
        return [];
      }
    }
  },
  watch: {
    data() {
      this.updateChart();
    }
  },
  mounted() {
    this.chart = new Chart(this.$refs.chart, {
      type: 'doughnut',
      data: {
        labels: [],
        datasets: []
      },
      options: {
        maintainAspectRatio: false,
        title: {
          display: true,
          text: this.$t('Screen Resolutions')
        },
        legend: {
          position: 'bottom',
          labels: {
            usePointStyle: true
          }
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const label = data.labels[tooltipItem.index];
              const value = parseInt(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]).toLocaleString();
              return `${label} (${value})`;
            }
          }
        }
      }
    });
    this.updateChart();
  },
  methods: {
    // Updates and renders the chart
    updateChart() {
      if (this.chartData) {
        this.chart.data = this.chartData;
        this.chart.update();
      }
    }
  }
};
</script>

<template>
  <div v-loading="loading">
    <div class="screen-resolutions-chart">
      <canvas ref="chart" />
    </div>

    <el-table :data="tableData">
      <el-table-column :label="$t('Devices')" prop="screenResolution" />
      <el-table-column :label="$t('Visits')" prop="visits" />
      <el-table-column label="%" prop="visitsPercentage" />
    </el-table>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.screen-resolutions-chart {
  position: relative;
  height: 20rem;
  margin-bottom: 2rem;

  @include breakpoint('sm-and-down') {
    height: 14rem;
  }
}
</style>
